import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../../Services/_states';
import { authzContextAtom } from '../../authorization/authzState';
import { canAccess } from '../../authorization/canAccess';
import { getRouteAccessByPath } from '../../config/authorization/routeRegistry';
import AccessDeniedPage from '../../authorization/AccessDeniedPage';
import { ROUTES } from '../../constants/routes';

/**
 * @param {{
 *   element: React.ReactNode,
 *   permissionGranted?: boolean,
 *   access?: import('../../authorization/types/authz.types').AuthzRequirement,
 * }} props
 */
const ProtectedRoute = ({ element, permissionGranted, access }) => {
  const auth = useRecoilValue(authAtom);
  const authz = useRecoilValue(authzContextAtom);
  const location = useLocation();

  if (!auth?.token) {
    return <Navigate to={ROUTES.APP.LOGIN} replace />;
  }

  if (authz.isAuthzV2Enabled && !authz.isFullAccess) {
    const registryEntry = getRouteAccessByPath(location.pathname);
    const resolvedAccess = access !== undefined ? access : registryEntry?.access;

    if (registryEntry == null && access === undefined) {
      return <AccessDeniedPage />;
    }

    if (!canAccess(authz, resolvedAccess ?? null)) {
      return <AccessDeniedPage />;
    }
    return element;
  }

  if (permissionGranted === false) {
    return <Navigate to={ROUTES.APP.ACCESS_DENIED} replace />;
  }

  return element;
};

export default ProtectedRoute;
